import script from "./CustomerKhataDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerKhataDetails.vue?vue&type=script&setup=true&lang=js"

import "./CustomerKhataDetails.vue?vue&type=style&index=0&id=7d7ae584&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7ae584"]])

export default __exports__